import React from 'react';

import { SideBarPageGroups } from '../types/enums';

type AppContainerContextType = {
  setShowContactModal: React.Dispatch<React.SetStateAction<boolean>>;
  openPageGroups: SideBarPageGroups[];
  setOpenPageGroups: React.Dispatch<React.SetStateAction<SideBarPageGroups[]>>;
};

export const AppContainerContext = React.createContext<AppContainerContextType>(undefined);

export function useAppContainerContext() {
  return React.useContext(AppContainerContext);
}
